export default __webpack_public_path__ + "media/images/svg/ico-search-b609ce6ab484235c214099f6c24304dc.svg";